<td [colSpan]="activecolumns">
    <div
        class="details-container row-expanded"
        *ngIf="member.active === true"
    >
        <div>
            <div class="member-coaching-details">
                <div class="detail-tabs">
                    <div class="tab-content tab-content-perf">
                        <div
                            role="tabpanel"
                            class="tab-pane active ng-star-inserted"
                            aria-labelledby="tab-observations"
                            id="tab-observations-panel"
                            aria-expanded="true"
                        >
                            <div class="row member-perf">
                                <div class="perf-content perf-content-graph">
                                    <div class="perf-tabs-container">
                                        <span
                                            class="perf-tabs-container-title perf-tabs-container-metric-title"
                                        >
                                            {{ oppTypeLabel }}
                                        </span>

                                        <elastic-tabs
                                            [input]="activeSubTab"
                                            [tabsconfig]="perfTabsConfig"
                                            [inputclass]="
                                                'nav nav-tabs nav-performers perf-tabs history-tabs justify-content-start'
                                            "
                                        >
                                        </elastic-tabs>

                                        <span class="clearfix"></span>
                                        <button
                                            class="uncoached-button"
                                            [ngClass]="{
                                                active:
                                                    showUncoachedFlag === true
                                            }"
                                            (click)="toggleUncoached()"
                                            documentBlurTrigger
                                            [triggerFlag]="showUncoachedFlag"
                                            (documentBlurred)="
                                                toggleUncoached(false)
                                            "
                                        >
                                            <span>
                                                {{
                                                    i18n._7399_UNCOACHED_OPPORTUNITIES
                                                        | translate
                                                }}
                                                <small
                                                    class="uncoached-count"
                                                    *ngIf="member.uncoached"
                                                >
                                                    {{
                                                        member.uncoached.length
                                                    }}
                                                </small>
                                            </span>
                                        </button>
                                    </div>

                                    <div
                                        class="uncoached-metrics"
                                        [ngClass]="{
                                            show: showUncoachedFlag === true
                                        }"
                                    >
                                        <h4>
                                            {{
                                                i18n._7399_UNCOACHED_OPPORTUNITIES
                                                    | translate
                                            }}
                                        </h4>

                                        <ng-container
                                            *ngIf="
                                                member.uncoached;
                                                else noUncoached
                                            "
                                        >
                                            <div class="opplist">
                                                <ng-container
                                                    *ngFor="
                                                        let opp of member.uncoached
                                                    "
                                                >
                                                    <metric-button
                                                        [opportunity]="opp"
                                                        [withTooltip]="false"
                                                        (click)="
                                                            onActiveMetricSelected(
                                                                opp.metricId
                                                            );
                                                            toggleUncoached()
                                                        "
                                                    >
                                                    </metric-button>
                                                </ng-container>
                                            </div>
                                        </ng-container>

                                        <ng-template #noUncoached>
                                            <div class="opplist">
                                                {{
                                                    i18n._7400_NO_OPPORTUNITIES_NEED_ATTENTION_
                                                        | translate
                                                }}.
                                            </div>
                                        </ng-template>
                                    </div>

                                    <div class="row">
                                        <div class="col-lg-12 nogutter px-3">
                                            <div class="row mx-0">
                                                <div class="col-12 pl-0 mx-0">
                                                    <div class="row mx-0">
                                                        <div class="col-md-7">
                                                            <div
                                                                class="row align-items-center"
                                                            >
                                                                <div
                                                                    class="col-sm-6 py-2 metrics-select-sec"
                                                                >
                                                                    <label
                                                                        class="mb-0"
                                                                    >
                                                                        {{
                                                                            i18n._527_METRICS
                                                                                | translate
                                                                        }}</label
                                                                    >
                                                                    <ng-select
                                                                        [notFoundMsg]="
                                                                            i18n._7413_NO_RESULTS_FOUND
                                                                                | translate
                                                                        "
                                                                        [placeholder]="
                                                                            i18n._7401_SELECT_METRIC_
                                                                                | translate
                                                                        "
                                                                        class="metricsdropdown"
                                                                        [options]="
                                                                            metricOptions
                                                                        "
                                                                        [ngModel]="
                                                                            activeMetric.metricIdString
                                                                        "
                                                                        (ngModelChange)="
                                                                            onActiveMetricSelected(
                                                                                $event
                                                                            )
                                                                        "
                                                                        forceDropdownPosition
                                                                    >
                                                                        <ng-template
                                                                            #optionTemplate
                                                                            let-opp="option"
                                                                            let-index="index"
                                                                        >
                                                                            <metric-button
                                                                                *ngIf="
                                                                                    opp.metricId !=
                                                                                    null
                                                                                "
                                                                                [opportunity]="
                                                                                    opp
                                                                                "
                                                                                [withTooltip]="
                                                                                    false
                                                                                "
                                                                                [disableClick]="
                                                                                    true
                                                                                "
                                                                            >
                                                                            </metric-button>
                                                                        </ng-template>
                                                                    </ng-select>
                                                                </div>
                                                                <div
                                                                    class="col-sm-6 py-2 components-select-sec"
                                                                    *ngIf="
                                                                        activeMetric.components &&
                                                                        activeMetric
                                                                            .components
                                                                            .length &&
                                                                        activeSubTab ==
                                                                            GraphType.TREND
                                                                    "
                                                                >
                                                                    <label
                                                                        class="mb-0"
                                                                    >
                                                                        {{
                                                                            i18n._7402_COMPONENT
                                                                                | translate
                                                                        }}</label
                                                                    >
                                                                    <ng-select
                                                                        [options]="
                                                                            componentsOptions
                                                                        "
                                                                        [notFoundMsg]="
                                                                            i18n._7413_NO_RESULTS_FOUND
                                                                                | translate
                                                                        "
                                                                        [multiple]="
                                                                            false
                                                                        "
                                                                        [multipleWithCheckbox]="
                                                                            true
                                                                        "
                                                                        [multipleOptionsSelectedLabel]="
                                                                            i18n._7403_MULTIPLE_COMPONENTS_SELECTED
                                                                                | translate
                                                                        "
                                                                        [allOptionsSelectedLabel]="
                                                                            i18n._7404_ALL_COMPONENTS_SELECTED
                                                                                | translate
                                                                        "
                                                                        (selected)="
                                                                            onComponentSelected(
                                                                                $event
                                                                            )
                                                                        "
                                                                        (selectedAll)="
                                                                            onAllComponentSelected(
                                                                                $event
                                                                            )
                                                                        "
                                                                        (deselected)="
                                                                            onComponentDeselected(
                                                                                $event
                                                                            )
                                                                        "
                                                                        (deselectedAll)="
                                                                            onAllComponentDeselected(
                                                                                $event
                                                                            )
                                                                        "
                                                                        [ngModel]="
                                                                            selectedComponents
                                                                        "
                                                                        forceDropdownPosition
                                                                    >
                                                                    </ng-select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="col-md-5 text-right select-period-sec"
                                                            *ngIf="
                                                                activeSubTab !=
                                                                GraphType.GRID
                                                            "
                                                        >
                                                            <div class="mt-2">
                                                                <div
                                                                    class="btn-group btn-group-toggle"
                                                                    [ngModel]="
                                                                        localPeriodType
                                                                    "
                                                                    (ngModelChange)="
                                                                        onPeriodTypeClick(
                                                                            $event
                                                                        )
                                                                    "
                                                                    ngbRadioGroup
                                                                >
                                                                    <label
                                                                        class="btn btn-secondary"
                                                                        ngbButtonLabel
                                                                    >
                                                                        <input
                                                                            type="radio"
                                                                            [value]="
                                                                                PeriodType.DAY
                                                                            "
                                                                            ngbButton
                                                                        />
                                                                        {{
                                                                            i18n._202_DAILY
                                                                                | translate
                                                                        }}
                                                                    </label>
                                                                    <label
                                                                        class="btn btn-secondary"
                                                                        ngbButtonLabel
                                                                    >
                                                                        <input
                                                                            type="radio"
                                                                            [value]="
                                                                                PeriodType.WEEK
                                                                            "
                                                                            ngbButton
                                                                        />
                                                                        {{
                                                                            i18n._203_WEEKLY
                                                                                | translate
                                                                        }}
                                                                    </label>
                                                                    <label
                                                                        class="btn btn-secondary"
                                                                        ngbButtonLabel
                                                                    >
                                                                        <input
                                                                            type="radio"
                                                                            [value]="
                                                                                PeriodType.MONTH
                                                                            "
                                                                            ngbButton
                                                                        />
                                                                        {{
                                                                            i18n._204_MONTHLY
                                                                                | translate
                                                                        }}
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="col-md-5 py-2"
                                                            *ngIf="
                                                                activeSubTab ==
                                                                GraphType.GRID
                                                            "
                                                        >
                                                            <div class="row">
                                                                <div
                                                                    class="col-12"
                                                                >
                                                                    <label
                                                                        class="mb-0"
                                                                    >
                                                                        {{
                                                                            i18n._773_PERIOD
                                                                                | translate
                                                                        }}</label
                                                                    >
                                                                    <ng-select
                                                                        class=""
                                                                        [notFoundMsg]="
                                                                            i18n._7413_NO_RESULTS_FOUND
                                                                                | translate
                                                                        "
                                                                        [placeholder]="
                                                                            i18n._7405_SELECT_PERIOD_
                                                                                | translate
                                                                        "
                                                                        [options]="
                                                                            COACHING_PERFORMANCE_PERIOD_TYPES
                                                                        "
                                                                        [ngModel]="
                                                                            daterange ==
                                                                            null
                                                                                ? null
                                                                                : [
                                                                                      daterange
                                                                                  ]
                                                                        "
                                                                        (ngModelChange)="
                                                                            daterange =
                                                                                $event ===
                                                                                ''
                                                                                    ? null
                                                                                    : $event;
                                                                            onDateRangeChange(
                                                                                $event
                                                                            )
                                                                        "
                                                                        forceDropdownPosition
                                                                    >
                                                                    </ng-select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div
                                            class="col-12"
                                            *ngIf="hasPendingData === true"
                                        >
                                            <cmps-wait-status
                                                class="p-2"
                                            ></cmps-wait-status>
                                        </div>
                                    </div>

                                    <div
                                        class="tab-content trend-grid-panels"
                                        [ngClass]="{
                                            fade: showUncoachedFlag === true
                                        }"
                                    >
                                        <div
                                            role="tabpanel"
                                            [hidden]="
                                                activeSubTab !=
                                                GraphType.VARIANCE
                                            "
                                            class="tab-pane ng-star-inserted"
                                            [class.active]="
                                                activeSubTab ==
                                                GraphType.VARIANCE
                                            "
                                        >
                                            <div
                                                class="row chart"
                                                *ngIf="
                                                    !hasPendingData &&
                                                    startInitVariance == true
                                                "
                                            >
                                                <div
                                                    class="col-lg-12 line-area-chart-container"
                                                    #perfContent
                                                >
                                                    <person-performance-variance
                                                        [activeMetric]="
                                                            activeMetric
                                                        "
                                                        [periodType]="
                                                            globalPeriodType
                                                                | async
                                                        "
                                                        [data]="
                                                            actualVarianceData
                                                        "
                                                        [graphType]="
                                                            activeSubTab
                                                        "
                                                        (doneRendering)="
                                                            hasPendingData =
                                                                $event
                                                        "
                                                    >
                                                    </person-performance-variance>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            role="tabpanel"
                                            [hidden]="
                                                activeSubTab != GraphType.TREND
                                            "
                                            class="tab-pane ng-star-inserted"
                                            [class.active]="
                                                activeSubTab == GraphType.TREND
                                            "
                                        >
                                            <div
                                                class="row chart"
                                                [class.transparentgraph]="
                                                    loadedTrend == false
                                                "
                                                *ngIf="
                                                    !hasPendingData &&
                                                    startInitTrend == true
                                                "
                                            >
                                                <div
                                                    class="col-lg-12"
                                                    #perfContent
                                                >
                                                    <person-performance-variance
                                                        [activeMetric]="
                                                            activeMetric
                                                        "
                                                        [periodType]="
                                                            globalPeriodType
                                                                | async
                                                        "
                                                        [data]="actualTrendData"
                                                        [graphType]="
                                                            activeSubTab
                                                        "
                                                        [componentData]="
                                                            componentData
                                                        "
                                                        (doneRendering)="
                                                            hasPendingData =
                                                                $event
                                                        "
                                                    >
                                                    </person-performance-variance>
                                                </div>
                                            </div>
                                        </div>

                                        <div
                                            role="tabpanel"
                                            [hidden]="
                                                activeSubTab != GraphType.GRID
                                            "
                                            class="tab-pane ng-star-inserted"
                                            [class.active]="
                                                activeSubTab == GraphType.GRID
                                            "
                                        >
                                            <div
                                                class="row mx-0"
                                                *ngIf="
                                                    !hasPendingData &&
                                                    startInitGrid == true
                                                "
                                            >
                                                <div
                                                    class="col-lg-12 border-right-oa"
                                                    #perfContent
                                                >
                                                    <person-performance-data-grid
                                                        [activeMetric]="
                                                            activeMetric
                                                        "
                                                        [data]="actualGridData"
                                                        [periods]="gridPeriods"
                                                        [componentLength]="
                                                            componentLength
                                                        "
                                                        [metricNames]="
                                                            metricnames
                                                        "
                                                    >
                                                    </person-performance-data-grid>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        [ngClass]="{
                                            fade: showUncoachedFlag === true
                                        }"
                                        class="main-tab-btns-sec pt-4"
                                    >
                                        <button
                                            (click)="newObservation()"
                                            class="main-tab-sec-btns btn btn-primary"
                                        >
                                            <cmps-icon
                                                svgIcon="account-eye"
                                            ></cmps-icon>
                                            <span class="cmps-cdk-pl-0dot75">
                                                {{
                                                    i18n._7406_START_OBSERVATION
                                                        | translate
                                                }}</span
                                            >
                                        </button>
                                        <button
                                            (click)="newCommitment()"
                                            class="main-tab-sec-btns btn btn-primary"
                                        >
                                            <cmps-icon
                                                svgIcon="handshake-outline"
                                            ></cmps-icon>
                                            <span class="cmps-cdk-pl-0dot75">
                                                {{
                                                    i18n._7407_START_COMMITMENT
                                                        | translate
                                                }}</span
                                            >
                                        </button>
                                    </div>
                                </div>

                                <div
                                    class="perf-content perf-content-commitments"
                                >
                                    <div class="commitments-section">
                                        <cmps-current-commitments
                                            [member]="member"
                                            [opportunityselected]="activeMetric"
                                            [openNonKPI]="openNonKPI"
                                            [periodType]="daterange"
                                        >
                                        </cmps-current-commitments>
                                    </div>
                                </div>
                            </div>

                            <!-- COACHING HISTORY -->
                            <button
                                class="show-history-button borderless-button"
                                (click)="toggleHistory(historyElement)"
                                [ngClass]="{
                                    active: showCommitmentHistory == true
                                }"
                            >
                                <cmps-icon
                                    [svgIcon]="
                                        showCommitmentHistory === true
                                            ? 'chevron-down'
                                            : 'chevron-right'
                                    "
                                ></cmps-icon>
                                <span>
                                    {{
                                        (showCommitmentHistory === false
                                            ? i18n._7392_VIEW_COACHING_HISTORY
                                            : i18n._7393_HIDE_COACHING_HISTORY
                                        ) | translate
                                    }}
                                </span>
                            </button>

                            <div
                                class="row p-3"
                                #historyElement
                            >
                                <person-oa-history
                                    *ngIf="showCommitmentHistory === true"
                                    [performerId]="member.userId"
                                    class="col-md-12 history-container"
                                >
                                </person-oa-history>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</td>
